import React from "react";
import { gettext } from "web/script/modules/django-i18n";
import SVGIcon from "web/react/components/svg-icon/svg-icon";

import { useFooterContext } from "./footer";
import FooterBlock from "./footer-block";
import styles from "./footer-gender-links.css";

export const WOMEN = "women";
export const MEN = "men";

interface LinkProps {
    url: string;
    name: string;
}

interface LinksBlockProps {
    links: LinkProps[];
    extraLinksEnabled: boolean;
    allLink: string;
}

function LinksBlock({ links, extraLinksEnabled, allLink }: LinksBlockProps): JSX.Element {
    return (
        <>
            <ul>
                {links.map((link) => (
                    <li key={link.url}>
                        <a className={styles.link} href={link.url}>
                            {link.name}
                        </a>
                    </li>
                ))}
            </ul>
            {!extraLinksEnabled && (
                <div className={styles.viewAllBlock}>
                    <a className={styles.viewAllLink} href={allLink}>
                        {gettext("site_links.view_all")} {/* View all */}
                    </a>
                    <SVGIcon className={styles.arrowIcon} name="arrow-icon" />
                </div>
            )}
        </>
    );
}

interface FooterGenderLinksProps {
    gender: "men" | "women";
}

function FooterGenderLinks({ gender }: FooterGenderLinksProps): JSX.Element | null {
    const {
        data: {
            men_links_enabled: menLinksEnabled,
            women_links_enabled: womenLinksEnabled,
            extra_links_enabled: extraLinksEnabled,
            men_links: menLinks,
            women_links: womenLinks,
            shop_gender_men_link: shopGenderMenLink,
            shop_gender_women_link: shopGenderWomenLink,
        },
        openBlockId,
        setOpenBlock,
    } = useFooterContext();

    if (gender === MEN && !menLinksEnabled) {
        return null;
    }

    if (gender === MEN) {
        return (
            <FooterBlock
                title={gettext("footer.links_for_men.title")}
                isOpen={openBlockId === MEN}
                onClick={(): void => setOpenBlock(MEN)}
            >
                <LinksBlock
                    links={menLinks}
                    extraLinksEnabled={extraLinksEnabled}
                    allLink={shopGenderMenLink}
                />
            </FooterBlock>
        );
    }

    if (gender === WOMEN && !womenLinksEnabled) {
        return null;
    }

    if (gender === WOMEN) {
        return (
            <FooterBlock
                title={gettext("footer.links_for_women.title")}
                isOpen={openBlockId === WOMEN}
                onClick={(): void => setOpenBlock(WOMEN)}
            >
                <LinksBlock
                    links={womenLinks}
                    extraLinksEnabled={extraLinksEnabled}
                    allLink={shopGenderWomenLink}
                />
            </FooterBlock>
        );
    }

    return null;
}

export default FooterGenderLinks;
